import  ApiService  from '../../services/api.service'

const state =  {
    loading: false,
    offerList: []
}
const getters = {
    loading: state => state.loading,
    offerList: state => state.offerList,
}

const mutations = {
    setLoading(state, value) {
        state.loading = value;
    },
    setOfferList(state, value) {
        state.offerList = value;
    }
}

const actions = {
    fetchOffers({ commit }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('/offers')
            .then(response => {
                commit('setOfferList', response.data) 
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
                commit('setLoading', false)
            })
        });
    }
}           
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}